import React, {useEffect, useRef, useState} from "react";
import {Steps, Button as Button2} from "antd";
import {Button, Col, Row} from "react-bootstrap";
import TextArea from "../../../../common/TextArea";
import moment from "moment/moment";
import ImageGallery from "react-image-gallery";
import {stepContentMap} from "./primer-pos-configuration-steps";
import {isEmpty} from "../../../../../_helpers/commonFunctions";
import axios from "axios";
import {toast} from "react-toastify";
import {setSelectedPrimerPos} from "../../../../../_reducers/DataPanel/Clients/clientSlice";
import {useDispatch} from "react-redux";
import Input from "../../../../common/Input";
import Dropdown from "../../../../primer/Dropdown";

const { Step } = Steps;

const PrimerPosConfigurationStep = ({ step, onChange, selectedPos, saveNotes }) => {
    const dispatch = useDispatch();
    const galleryRef = useRef(null);
    const content = stepContentMap[step.code] || {};
    const [notesLoader, setNotesLoader] = useState(false);
    const [simLoader, setSimLoader] = useState(false);
    const [sunmiLoader, setSunmiLoader] = useState(false);
    const [simStatus, setSimStatus] = useState('T');
    const [currentInnerStep, setCurrentInnerStep] = useState(step?.status === "completed" ? ((content?.steps?.length - 1) || 0) : 0);

    const allSteps = Array.isArray(content?.steps) ? content.steps : [];
    const currentStep = allSteps.find((s, index) => index === currentInnerStep) || {};
    const images =  (step?.code === "setUpCredentialsAndInstallApps" && (currentInnerStep === 1 || currentInnerStep === 2) && selectedPos?.orderCoupons?.includes("viva")) ? currentStep?.imagesViva :
        (step?.code === "setUpCredentialsAndInstallApps" && (currentInnerStep === 1 || currentInnerStep === 2) && selectedPos?.orderCoupons?.includes("piraeus")) ? currentStep?.imagesEpay :
            (currentStep.images || []);


    const next = () => {
        setCurrentInnerStep(currentInnerStep + 1);
    };

    const prev = () => {
        setCurrentInnerStep(currentInnerStep - 1);
    };

    const statusListDropdownOptions = [
        { value: 'T', label: 'Active.Test' },
        { value: 'R', label: 'Active.Ready' },
        { value: 'A', label: 'Active.Live' },
        { value: 'D', label: 'Inactive.Stopped' },
        { value: 'S', label: 'Active.Suspend (NB service disabled)' },
    ];

    useEffect(() => {
        if(currentInnerStep === 2 && step?.code === "testDevice") {
            getSunmiDeviceInfo();
        }
    }, [currentInnerStep]);

    const getSunmiDeviceInfo = () => {
        if(!isEmpty(selectedPos) && selectedPos?.serialNumber) {
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-sunmi-api", {_id: selectedPos?._id, action: "getDeviceInfo", isOnline: false}, {headers: {"Content-Type": "application/json"}})
                .then((res) => {
                    if(res.data.status === "200") {
                        if(!isEmpty(res.data?.object)) {
                            dispatch(setSelectedPrimerPos(res.data.object));
                        }
                    } else {
                        toast.error(res.data.message);
                    }
                }).catch(() => {
                toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
            })
        } else {
            toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
        }
    }
    const sunmiRemoteControl = () => {
        if(!isEmpty(selectedPos) && selectedPos?.serialNumber) {
            let requestData = {
                _id: selectedPos?._id,
                action: "remoteControl"
            }
            setSunmiLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-sunmi-api", requestData, {headers: {"Content-Type": "application/json"}})
                .then((res) => {
                    setSunmiLoader(false);
                    if(res.data.status === "200") {
                        toast.success(res.data.message);
                            window.open(res.data.data, "_blank");
                        if(res.data?.object) dispatch(setSelectedPrimerPos(res.data.object));
                    } else {
                        toast.error(res.data.message);
                    }
                }).catch(() => {
                toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
                setSunmiLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
        }
    }

    const changeSimStatus = () => {
        if(!isEmpty(selectedPos?.simId) && !isEmpty(simStatus)) {
            const requestData = {_id: selectedPos?._id, action: "changeStatus", sim: selectedPos.simId, status: simStatus};
            setSimLoader(true);
            axios.post(process.env.REACT_APP_API_URL2 + "/client/primer-pos-vodafone-api", requestData, {headers: {"Content-Type": "application/json"}})
                .then((res) => {
                    setSimLoader(false);
                    if(res.data.status === "200") {
                        toast.success(res.data.message);
                        if(res.data?.data?.state) setSimStatus(res.data?.data?.state);
                        if(res.data?.object) dispatch(setSelectedPrimerPos(res.data.object));
                    } else {
                        toast.error(res.data.message);
                    }
                }).catch(() => {
                toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
                setSimLoader(false);
            })
        } else {
            toast.error("Κάτι πήγε στραβά! Παρακαλώ ξαναπροσπαθήστε.");
        }
    }

    return (
        <div style={{flex: 1, display: "flex", flexDirection: "column", overflowY: "auto"}}>
            <div className="d-flex justify-content-between mb-1">
                <div style={{flex: 1, display: "flex", flexWrap: "wrap", maxHeight: "60vh", overflowY: "auto", overflowX: "hidden", marginRight: "50px", alignItems: "flex-start"}}>
                    <Steps
                        direction="horizontal"
                        current={currentInnerStep}
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            gap: "25px",
                        }}
                        percent={(currentInnerStep + 1) / allSteps.length * 100}
                    >
                        {allSteps.map((stepItem, index) => (
                            <Step
                                key={`innerStep_${index}`}
                                style={{
                                    minWidth: "20vw",
                                    maxWidth: "20vw",
                                    cursor: "pointer",
                                    minHeight: "130px",
                                    border: currentInnerStep === index ? "3px solid #76AEB7" : "0px",
                                    borderRadius: currentInnerStep === index ? "25px" : "0px",
                                    padding:  currentInnerStep === index ? "5px" : "0px",
                                    backgroundColor: currentInnerStep === index ? "lightgray" : "white",

                            }}
                                title={stepItem.title}
                                description={
                                (step?.code === "setUpCredentialsAndInstallApps" && index === 1 && selectedPos?.orderCoupons?.includes("viva")) ? stepItem?.descriptionViva :
                                (step?.code === "setUpCredentialsAndInstallApps" && index === 1 && selectedPos?.orderCoupons?.includes("piraeus")) ? stepItem?.descriptionEpay :
                                stepItem.description
                            }
                                onClick={() => setCurrentInnerStep(index)}
                            />
                        ))}
                    </Steps>
                    {(step?.code === "testDevice" && currentInnerStep === 2) && (
                        <Row className="align-items-center">
                            <Col md={5}>
                                <Input
                                    label={"SIM ICCID"}
                                    className={"mb-3"}
                                    name={"iccid"}
                                    disabled={true}
                                    type={"text"}
                                    value={selectedPos?.simId ? selectedPos.simId : "Δεν βρέθηκε SIM!"}
                                />
                            </Col>
                            <Col md={4}>
                                <Dropdown
                                    name={"simState"}
                                    label={"Κατάσταση SIM"}
                                    disabled={simLoader}
                                    required={true}
                                    key={Math.random()}
                                    defaultValue={statusListDropdownOptions.find((el) => el.value === simStatus)}
                                    options={statusListDropdownOptions}
                                    onChange={(e) => setSimStatus(e.value)}
                                />
                            </Col>
                            <Col md={3}>
                                <Button
                                    variant="primary"
                                    disabled={simLoader || isEmpty(selectedPos?.simId)}
                                    onClick={() => changeSimStatus()}>
                                    {"Ενεργοποίηση SIM "}
                                    {simLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                                </Button>
                            </Col>
                        </Row>
                    )}
                    {step?.code === "setUpCredentialsAndInstallApps" && (
                            <Row className="align-items-center" style={{flex: 1}}>
                                <hr style={{marginTop: "0px", marginBottom: "0.3rem"}} />
                                <p className="text-muted mb-1"><i>Credentials eΤαμειακής:</i></p>
                                {(isEmpty(selectedPos?.linkedCredentials?.serialNumber) && selectedPos?.status === "available") && (
                                    <p className="mb-1" style={{color: "red", fontWeight: 'bold', fontSize: "15px"}}>
                                        ΠΡΟΣΟΧΗ! Η συσκευή δεν έχει δεσμευτεί ακόμα σε πελάτη! Παρακαλώ σταματήστε την παραμετροποίηση εδώ και επανέλθετε όταν η συσκευή δεσμευτεί.
                                    </p>
                                )}
                                {(isEmpty(selectedPos?.linkedCredentials?.serialNumber) && selectedPos?.status !== "available") && (
                                    <p className="mb-1" style={{color: "orange", fontWeight: 'bold', fontSize: "15px"}}>
                                        ΠΡΟΣΟΧΗ! Η αγορά της συσκευής έγινε χωρίς επιπλέον λογισμικό! Προχωρήστε στα επόμενα βήματα και παραλείψτε την εισαγωγή κλειδιών.
                                    </p>
                                )}
                                <Col md={3}>
                                    <Input
                                        label={"Σειριακός Αριθμός"}
                                        className={"mb-3"}
                                        name={"serialNumber"}
                                        disabled={true}
                                        type={"text"}
                                        value={selectedPos?.linkedCredentials?.serialNumber ? selectedPos.linkedCredentials.serialNumber : "Δεν βρέθηκε Σειριακός!"}
                                    />
                                </Col>
                                <Col md={2}>
                                    <Input
                                        label={"Όνομα Χρήστη"}
                                        className={"mb-3"}
                                        name={"username"}
                                        disabled={true}
                                        type={"text"}
                                        value={selectedPos?.linkedCredentials?.username ? selectedPos.linkedCredentials.username : "Δεν βρέθηκε Όνομα Χρήστη!"}
                                    />
                                </Col>
                                <Col md={2}>
                                    <Input
                                        label={"Κωδικός Χρήστη"}
                                        className={"mb-3"}
                                        name={"password"}
                                        disabled={true}
                                        type={"text"}
                                        value={selectedPos?.linkedCredentials?.password ? selectedPos.linkedCredentials.password : "Δεν βρέθηκε Κωδικός!"}
                                    />
                                </Col>
                                <Col md={2}>
                                    <Input
                                        label={"Κουπόνια Αγοράς"}
                                        className={"mb-3"}
                                        name={"coupons"}
                                        disabled={true}
                                        type={"text"}
                                        value={selectedPos?.orderCoupons?.length > 0 ? selectedPos.orderCoupons.join(", ") : "Δεν βρέθηκε Κουπόνι!"}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Button
                                        variant="primary"
                                        disabled={sunmiLoader || isEmpty(selectedPos?.serialNumber)}
                                        onClick={() => sunmiRemoteControl()}>
                                        {"Απομακρυσμένος Έλεγχος "}
                                        {sunmiLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status" aria-hidden="true"></span>)}
                                    </Button>
                                </Col>
                            </Row>

                    )}
                </div>
                <div style={{flexShrink: 1, alignItems: 'center', marginRight: "5px"}}>
                    <ImageGallery
                    originalHeight={"50px"}
                    showIndex={images.length > 1}
                    showBullets={images.length > 1}
                    additionalClass={"image-gallery-class"}
                    items={images}
                    showPlayButton={false}
                    showNav={true}
                    ref={galleryRef}
                    onClick={() => galleryRef?.current?.toggleFullScreen()}
                    showThumbnails={false}
                />
                <div style={{ marginTop: "5px", textAlign: 'center' }}>
                    <Button2 disabled={currentInnerStep === 0} color={"green"} style={{ margin: '0 8px'}} onClick={() => prev()}>
                        Προηγούμενο Βήμα
                    </Button2>
                    <Button2 color={"green"} type="primary" disabled={currentInnerStep >= allSteps.length - 1} onClick={() => next()}>
                        Επόμενο Βήμα
                    </Button2>
                </div>
                </div>
            </div>
            <div style={{marginTop: "auto"}}>
                <div className="d-flex justify-content-between">
                    <div style={{flex: 1.2}}>
                        <div className="d-flex justify-content-between align-items-center mb-1">
                            <div className="text-muted mb-2">
                                <i>Σημειώσεις Βήματος:</i>
                            </div>
                            <Button style={{padding: "7px"}} variant="primary" disabled={notesLoader}
                                    onClick={() => saveNotes(step, setNotesLoader)}>
                                {"Αποθήκευση Σημειώσεων "}
                                {notesLoader && (<span className="spinner-border spinner-border-sm ml-1" role="status"
                                                       aria-hidden="true"></span>)}
                            </Button>
                        </div>
                        <TextArea
                            rows={5}
                            value={step?.notes}
                            placeholder={"Πληκτρολογήστε Σημειώσεις Βήματος"}
                            autoComplete={"off"}
                            onChange={(e) => onChange(step.code, "notes", e.target.value)}
                        />
                    </div>
                    <div className={"ml-3"} style={{flex: 0.8}}>
                        <p className="text-muted mb-1"><i>Αρχείο Καταγραφής:</i></p>
                        <div style={{ maxHeight: '14vh', overflowY: 'auto', borderBottom: '1px black solid' }}>
                            <table style={{position: 'sticky', top: "0px"}} className={"simpleClassicTable"}>
                                <colgroup>
                                    <col span={1} style={{width: "30%"}}></col>
                                    <col span={1} style={{width: "40%"}}></col>
                                    <col span={1} style={{width: "30%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>Ημερομηνία</th>
                                    <th>Ενέργεια</th>
                                    <th>Χρήστης</th>
                                </tr>
                                </thead>
                            </table>
                            <table className={"simpleClassicTable"}>
                                <colgroup>
                                    <col span={1} style={{width: "30%"}}></col>
                                    <col span={1} style={{width: "40%"}}></col>
                                    <col span={1} style={{width: "30%"}}></col>
                                </colgroup>
                                <tbody>
                                {(step?.logs || [])
                                    .slice()
                                    .sort((a, b) => new Date(b.date) - new Date(a.date))
                                    .map((row, idx) => (
                                        <tr key={`fsHistoryStep-${row.id || idx}`}>
                                            <td>{moment(row.date).format("DD/MM/YYYY HH:mm:ss")}</td>
                                            <td>{row.action}</td>
                                            <td>{row.user}</td>
                                        </tr>
                                    ))
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PrimerPosConfigurationStep;